if (!customElements.get('asap-sidebar-menu')) {
  customElements.define('asap-sidebar-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.finishAll();
      this.controller = new AbortController();
      this.animations = new Map();
      const { signal } = this.controller;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('details').forEach(details => this.sync(details));
      this.addEventListener('toggle', event => {
        if (event.target.matches('details')) this.sync(event.target);
      }, { capture: true, signal });
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        const details = summary?.parentElement;
        if (!details?.matches('details') || !this.contains(details) || event.button > 0 ||
            this.motion.matches || window.Shopify?.designMode || typeof details.animate !== 'function') return;
        event.preventDefault();
        event.stopPropagation();
        this.toggle(details);
      }, { capture: true, signal });
      this.motion.addEventListener('change', () => this.finishAll(), { signal });
      window.addEventListener('resize', () => this.finishAll(), { passive: true, signal });
    }

    sync(details) {
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    }

    finish(details, entry) {
      if (this.animations?.get(details) !== entry) return;
      entry.animation.onfinish = null;
      entry.animation.oncancel = null;
      entry.animation.cancel();
      details.open = entry.open;
      details.style.overflow = entry.overflow;
      this.animations.delete(details);
      this.sync(details);
    }

    finishAll() {
      this.animations?.forEach((entry, details) => this.finish(details, entry));
    }

    toggle(details) {
      // Settle expanding ancestors before measuring a nested branch.
      this.animations.forEach((entry, ancestor) => {
        if (ancestor !== details && ancestor.contains(details)) this.finish(ancestor, entry);
      });
      const previous = this.animations.get(details);
      const open = previous ? !previous.open : !details.open;
      const start = details.getBoundingClientRect().height;
      const overflow = previous?.overflow ?? details.style.overflow;
      if (previous) {
        previous.animation.onfinish = null;
        previous.animation.oncancel = null;
        previous.animation.cancel();
        this.animations.delete(details);
      }
      details.open = false;
      const closedHeight = details.getBoundingClientRect().height;
      details.open = true;
      const end = open ? details.getBoundingClientRect().height : closedHeight;
      details.style.overflow = 'hidden';
      try {
        const animation = details.animate([{ height: `${start}px` }, { height: `${end}px` }], { duration: 240, easing: 'ease-in-out' });
        const entry = { animation, open, overflow };
        this.animations.set(details, entry);
        animation.onfinish = () => this.finish(details, entry);
        animation.oncancel = () => this.finish(details, entry);
      } catch {
        details.open = open;
        details.style.overflow = overflow;
        this.sync(details);
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.finishAll();
    }
  });
}
